import { createSlice } from '@reduxjs/toolkit'

const reducer = createSlice({
  name: 'local',
  initialState: {
    currentPage: 1,
    totalPages: null,
    alert: null,
    filters: {},
    submittedFilters: {},
    isDirty: false,
    dataLoading: false
  },
  reducers: {
    set: (s, a) => a.payload,
    upsert: (s, a) => ({ ...s, ...a.payload }),
    setFilter: (s, a) => {
      s.filters[a.payload.key] = a.payload.value
    }
  },
}).reducer

const actions = (dis, store, restClient) => {
  return {
    set: (payload) => {
      dis({ type: 'local/set', payload })
    },
    upsert: (payload) => {
      dis({ type: 'local/upsert', payload })
    },
    setFilter: (key, value) => {
      dis({ type: 'local/upsert', payload: { isDirty: true } })
      dis({ type: 'local/setFilter', payload: { key, value } })
    }
  }
}

export { reducer, actions }
export default { reducer, actions }
